import { create } from 'zustand';
import { SearchQuestionItem, searchQuestionService } from '@mygpt/app';

interface QuestionSuggestionState {
  loading: boolean;
  questionSuggestions: SearchQuestionItem[];
  searchPromise: Promise<void> | null;
  searchQuestion: (aiId: string, query: string, language: string, maxWaitTime?: number) => Promise<void>;
  clear: () => void;
}

export const useQuestionSuggestion = create<QuestionSuggestionState>((set, get) => ({
  loading: false,
  questionSuggestions: [],
  searchPromise: null,
  searchQuestion: async (aiId: string, query: string, language: string, maxWaitTime = 1000) => {
    // 如果查询内容长度小于等于1，不需要搜索
    if (query.trim().length <= 1) {
      return;
    }

    const searchPromise = async () => {
      set({ loading: true });
      try {
        const res = await searchQuestionService({ aiId, search: query, language });
        set({ questionSuggestions: res.data });
      } catch (error) {
        console.error(`searchQuestion error: ${error}`);
      } finally {
        set({ loading: false, searchPromise: null });
      }
    };

    const timeoutPromise = new Promise((resolve) => {
      setTimeout(resolve, maxWaitTime);
    });

    await Promise.race([searchPromise(), timeoutPromise]);
  },
  clear: () => set({ questionSuggestions: [], searchPromise: null }),
}));
